import React, { useState } from 'react';
import { socket } from "../socket";
import '../stylesheets/UIBar.css';
import {endSound, buttonSound, drawCardSound} from "./SoundEffects.js";
import { trackTurnEnded } from "../analytics";

export default function TestUI({ gameState }) {
    const gameId = gameState?.id;
    const amITheHost = gameState?.players?.[socket.id]?.isHost || false;
    const isMyTurn = gameState.turnOrder[gameState.turnIndex] === socket.id;

    // ======== Button Handlers: Send Request to Game Server ========
    const handleEndTurn = () => {
        if (!gameId) return;
        console.log(`TestUI: Sending action 'endTurn' for game ${gameId}`);

        trackTurnEnded(gameId);
        socket.emit("playerRequest", { gameId, type: "endTurn" });
    };

    const handleActionClick = (actionName) => {
        console.log(`TestUI: Sending action '${actionName}'`);
        socket.emit("clientMessage", `Action from TestUI: ${actionName}`);
    };

    const handleMove = () => {
        if (!gameId) return;
        console.log(`TestUI: Sending action 'move' for game ${gameId}`);
        socket.emit("playerRequest", { gameId, type: "move" });
    };

    const handleDrawCard = () => {
        if (!gameId) return;
        socket.emit("playerRequest", { gameId, type: "drawCard" });
    };

    return (
        <div className="test-ui-container">
            {amITheHost && (
                <div className="game-id-display">
                    <span>Game ID: <strong>{gameId}</strong></span>
                </div>
            )}
            <div className="test-ui-buttons">
                {isMyTurn && gameState.phase === 'awaitingMove' && (
                    <button onClick={() => { handleMove(); buttonSound();}} className="ui-start-menu-button">Roll & Move</button>
                )}
                {isMyTurn && gameState.phase === 'awaitingDraw' && (
                    <button onClick={() => { handleDrawCard(); drawCardSound();}} className="ui-start-menu-button">Draw Card</button>
                )}
                {/* <button onClick={() => handleActionClick('Skip')} className="start-menu-button">Skip</button> */}
                {amITheHost && (
                    <button onClick={() => { handleEndTurn(); endSound();}} className="ui-start-menu-button">End Turn</button>
                )}
            </div>
        </div>
    );
}